const VideoPlayer = ({ videoUrl }) => {
  if (!videoUrl) return null;

  // Convert sound:// to full URL
  let finalUrl = videoUrl;
  if (videoUrl.startsWith("sound://")) {
    finalUrl = videoUrl.replace("sound://", "https://s3nsoftware.com/");
  }

  const isYouTube = finalUrl.includes("youtube.com") || finalUrl.includes("youtu.be");

  const getEmbedUrl = (url) => {
    try {
      if (url.includes("youtube.com")) {
        const videoId = new URL(url).searchParams.get("v");
        return `https://www.youtube.com/embed/${videoId}`;
      } else if (url.includes("youtu.be")) {
        const videoId = url.split("youtu.be/")[1].split(/[?&]/)[0];
        return `https://www.youtube.com/embed/${videoId}`;
      }
    } catch (err) {
      console.error("Invalid YouTube URL", err);
    }
    return null;
  };

  if (isYouTube) {
    const embedUrl = getEmbedUrl(finalUrl);
    if (!embedUrl) return <p>Invalid YouTube link.</p>;

    return (
      <iframe
        width="560"
        height="315"
        src={embedUrl}
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        style={{ borderRadius: "8px", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}
      />
    );
  }

  // Default HTML5 video player
  return (
    <video
      width="560"
      height="315"
      controls
      style={{ borderRadius: "8px", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}
    >
      <source src={finalUrl} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  );
};

export default VideoPlayer;
